import { handleCallApiReducer } from 'utils/api';

export const mapToProductSocialMedia = (action, _draft) => {
  handleCallApiReducer(action, _draft, 'socialMedia');
};
export const mapToMappingMetadata = (action, _draft, key) => {
  handleCallApiReducer(action, _draft, key);
};
